import { metricKeys } from '@pulse/metrics';
import { ALL_TRAFFIC } from '@utils/filter';

export const aiPresetKeys = {
  AD_REACH: 'ad-reach',
  AD_PERFORMANCE: 'ad-perf',
};

export const aiPresetTitles = {
  'ad-reach': 'Ad Reach & Frequency',
  'ad-perf': 'Ad Performance',
};

export const genAIUsecases = ({ validateMetric, validateDimension }) => [
  {
    title: 'Ad Reach & Frequency',
    key: aiPresetKeys.AD_REACH,
    description:
      'Track Ad Frequency and Reach. Understand Ad Load and how for many Ad Impressions the Ad is watched completely. Track Ad Slates.',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.Plays),
        metrics: validateMetric([
          metricKeys.Plays,
          metricKeys.AdUniqueDevices,
          metricKeys.AdTotalMinutes,
          metricKeys.EndedPlaysPerUniqueDevice,
          metricKeys.AdCompletedCreativePlays,
          metricKeys.AdSlateDurationPct,
          metricKeys.AdSlatePlaysPct,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension(['OBJECT_NAME', 'm3.dv.n', 'LIVE_VIDEO', 'GEO_COUNTRY']),
        },
      },
    },
  },

  {
    title: 'Ad Performance',
    key: aiPresetKeys.AD_PERFORMANCE,
    description: 'Analyze Ad Performance and User Experience.',
    config: {
      metricsChartContainer: {
        metric: validateMetric(metricKeys.Plays),
        metrics: validateMetric([
          metricKeys.Plays,
          metricKeys.AdCompletedCreativePlays,
          metricKeys.Bitrate,
          metricKeys.VideoStartFailures,
          metricKeys.VideoPlaybackFailures,
          metricKeys.RebufferingRatio,
          metricKeys.VideoStartTime,
          metricKeys.ExitBeforeVideoStarts,
        ]),
      },
      common: {
        appliedFilters: [ALL_TRAFFIC],
      },
      'module:trends': {
        base: {
          dimensions: validateDimension([
            'OBJECT_NAME',
            'm3.dv.n',
            'c3.ad.position',
            'c3.ad.technology',
          ]),
        },
      },
    },
  },
];
